import React, { useContext, useState } from 'react';
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import { SettingsBannerContext } from '../../../contexts/SettingsBannerContext';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import './index.css';

export const Compliance = () => {
  const { isIABFormat, setIsIABFormat, isIABWeight, setIsIABWeight, isGloboFormat, setIsGloboFormat, isGloboWeight, setIsGloboWeight,
    globoWeightHosted, setGloboWeightHosted, globoWeightTag, setGloboWeightTag
  } = useContext(SettingsBannerContext);
  const { master } = useContext(MasterBannerContext);

	const [collapsedFormatDiv, setCollapsedFormatDiv] = useState(true);

	const handleCollapseFormat = () => {
		setCollapsedFormatDiv(!collapsedFormatDiv)
	};

  const [ iabTabActive, setIabTabActive ] = useState('iab');

  const handleIabTabActive = (type) => {
		setIabTabActive(`${type}`)
	};
  
    const formatos = [
      { minLargura: 160, minAltura: 640, maxLargura: 240, maxAltura: 960, pesoMaximo: "300kb" },
      { minLargura: 200, minAltura: 100, maxLargura: 300, maxAltura: 150, pesoMaximo: "100kb" },
      { minLargura: 300, minAltura: 50, maxLargura: 450, maxAltura: 75, pesoMaximo: "100kb" },
      { minLargura: 300, minAltura: 150, maxLargura: 450, maxAltura: 225, pesoMaximo: "200kb" },
      { minLargura: 300, minAltura: 300, maxLargura: 450, maxAltura: 450, pesoMaximo: "300kb" },
      { minLargura: 300, minAltura: 450, maxLargura: 450, maxAltura: 675, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 540, maxLargura: 450, maxAltura: 800, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 600, maxLargura: 450, maxAltura: 900, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 900, maxLargura: 450, maxAltura: 1350, pesoMaximo: "500kb" },
      { minLargura: 450, minAltura: 300, maxLargura: 675, maxAltura: 450, pesoMaximo: "400kb" },
      { minLargura: 540, minAltura: 300, maxLargura: 800, maxAltura: 450, pesoMaximo: "400kb" },
      { minLargura: 600, minAltura: 75, maxLargura: 1200, maxAltura: 150, pesoMaximo: "300kb" },
      { minLargura: 600, minAltura: 800, maxLargura: 900, maxAltura: 1200, pesoMaximo: "600kb" },
      { minLargura: 600, minAltura: 1067, maxLargura: 900, maxAltura: 1600, pesoMaximo: "600kb" },
      { minLargura: 800, minAltura: 600, maxLargura: 1200, maxAltura: 900, pesoMaximo: "600kb" },
      { minLargura: 800, minAltura: 1280, maxLargura: 1200, maxAltura: 1920, pesoMaximo: "600kb" },
      { minLargura: 900, minAltura: 90, maxLargura: 1800, maxAltura: 180, pesoMaximo: "400kb" },
      { minLargura: 900, minAltura: 225, maxLargura: 1800, maxAltura: 450, pesoMaximo: "500kb" },
      { minLargura: 900, minAltura: 450, maxLargura: 1800, maxAltura: 900, pesoMaximo: "500kb" },
      { minLargura: 1067, minAltura: 600, maxLargura: 1600, maxAltura: 900, pesoMaximo: "600kb" },
      { minLargura: 1280, minAltura: 800, maxLargura: 1920, maxAltura: 1200, pesoMaximo: "600kb" },
      { minLargura: null, minAltura: null, maxLargura: 120, maxAltura: 20, pesoMaximo: null },
      { minLargura: null, minAltura: null, maxLargura: 168, maxAltura: 28, pesoMaximo: null },
      { minLargura: null, minAltura: null, maxLargura: 216, maxAltura: 36, pesoMaximo: null },
      { minLargura: null, minAltura: null, maxLargura: 300, maxAltura: 250, pesoMaximo: "150kb" },
      { minLargura: null, minAltura: null, maxLargura: 160, maxAltura: 600, pesoMaximo: "150kb" },
      { minLargura: null, minAltura: null, maxLargura: 120, maxAltura: 60, pesoMaximo: "50kb" }
    ];
  
    function isFormatoValidoEWeight(width, height, size) {
      for (let formato of formatos) {
        if (
          width >= formato.minLargura &&
          width <= formato.maxLargura &&
          height >= formato.minAltura &&
          height <= formato.maxAltura
        ) {
          const pesoMaximo = formato.pesoMaximo;
          const pesoValido = pesoMaximo === null || size <= extrairPesoMaximo(pesoMaximo);
          return { formato, pesoValido };
        }
      }
      return { formato: null, pesoValido: false };
    }
    
    function extrairPesoMaximo(pesoMaximo) {
      const valorNumerico = parseFloat(pesoMaximo);
      if (!isNaN(valorNumerico)) {
        if (pesoMaximo.includes('kb')) {
          return valorNumerico;
        } else if (pesoMaximo.includes('mb')) {
          return valorNumerico * 1000;
        }
      }
      return Infinity;
    }
    
    const { formato, pesoValido } = isFormatoValidoEWeight(master.width, master.height, master.size);
    
    setIsIABFormat(formato !== null);
    setIsIABWeight(pesoValido);
    
    const pesoMaximo = formato ? formato.pesoMaximo : 'Desconhecido';
  
    const tooltips = {
      "300x50": "Formato em transição: Será substituído por banner horizontal 6x1.",
      "320x50": "Formato em transição: Será substituído por banner horizontal 6x1.",
      "970x250": "Formato em transição: Será substituído por banner horizontal 4x1.",
      "728x90": "Formato em transição: Será substituído por banner horizontal 8x1.",
      "300x1050": "Formato em transição: Será substituído por retrato vertical 1x3.",
      "300x600": "Formato em transição: Será substituído por retrato vertical 1x2.",
      "300x250": "Formato em transição: Será substituído por retrato vertical 1x1.",
      "160x600": "Formato em transição: Será substituído por retrato vertical 1x4.",
      "120x60": "Formato em transição: Será substituído por anúncio tamanho pequeno 2x1."
    };
  
    const formatoTooltip = tooltips[`${master.width}x${master.height}`];

    const formatosGlobo = [
      { largura: 300, altura: 250, pesoHosted: "150kb", pesoTag: "350kb" },
      { largura: 300, altura: 600, pesoHosted: "250kb", pesoTag: "550kb" },
      { largura: 320, altura: 50, pesoHosted: "100kb", pesoTag: "150kb" },
      { largura: 320, altura: 100, pesoHosted: "100kb", pesoTag: "150kb" },
      { largura: 970, altura: 90, pesoHosted: "150kb", pesoTag: "350kb" },
      { largura: 970, altura: 150, pesoHosted: "200kb", pesoTag: "450kb" },
      { largura: 970, altura: 250, pesoHosted: "250kb", pesoTag: "550kb" },
      { largura: 1248, altura: 250, pesoHosted: "250kb", pesoTag: "550kb" }
    ];
  
    const formatoGlobo = formatosGlobo.find(formato => {
      return formato.largura === master.width && 
             formato.altura === master.height;
    });

    if (formatoGlobo) {
      const { pesoHosted, pesoTag } = formatoGlobo;
      const isGloboWeight = parseInt(master.size) <= parseInt(pesoHosted);
      
      setIsGloboFormat(true);
      setIsGloboWeight(isGloboWeight);
      setGloboWeightHosted(pesoHosted);
      setGloboWeightTag(pesoTag);
    } else {
      setIsGloboFormat(false);
    }
    

    // console.log(master)
    
	return (

		<>
		<div style={{margin: '12px 12px 12px 14px'}}>
			<div className='propertiesTitleAndArrow'>
				<span style={{fontWeight: 'bold', fontSize: '16px', margin: '0 0 0px 2px'}}>Compliance</span>
				{collapsedFormatDiv ? 
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseFormat} style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '13px -1px 0 0'}}/> :
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseFormat} style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '13px -1px 0 0'}}/>
        }
			</div>
			<Divider className='propertiesDividerTitle' style={{margin: '-3px 0 0px 0'}} />

		{
			!collapsedFormatDiv ? 
                <div>
                    {isIABFormat ?
                    
                    <div className='iabContainer'>

                       <div className="iabContainerLogosBg">
                          <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none', borderLeft: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none', borderRight: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none'}} onClick={() => handleIabTabActive('iab')} >
                          {isIABWeight && master.duration * master.loop <= 15 ? 
                            <img className='containerIAB-title-yes' src="assets/logo_iab.png"></img>
                          :
                            <img className='containerIAB-title-no' src="assets/logo_iab.png"></img>
                          }
                          </div>
                          <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? 'none' : "1px solid #68498c99", borderLeft: iabTabActive === 'iab' ? 'none' : "1px solid #68498c99", borderRight: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 1)"}} onClick={() => handleIabTabActive('globo')} >
                          {isGloboWeight && master.duration*master.loop <= 15 && master.loop <= 3 ?
                            <img className='logoglobo-yes' src="assets/logo_globo.png"></img>
                          :
                            <img className='logoglobo-no' src="assets/logo_globo.png"></img>
                          }
                          </div>
                          <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '0px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? '#FFFFFF' : "1px solid #68498c99" }}></div>
                          <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', position: 'absolute', left: '130px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? "1px solid #68498c99" : '#FFFFFF'}}></div>
                        </div>

                        {iabTabActive === 'iab' ?
                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', padding: '10px 0 0 10px', borderBottom: "1px solid #68498c99", borderLeft: "1px solid #68498c99", borderRight: "1px solid #68498c99"}}>
                          <div>
                          <b>Formato:</b> {master.width}x{master.height}
                          {formatoTooltip ?
                              <Tooltip title={formatoTooltip}><span className='containerIAB-question'> (?)</span></Tooltip>
                              :
                              <Tooltip title={'Este formato é atualmente aceito pela IAB.'}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                          }
                          </div>
                          <div className='containerIAB-weight'>
                          <b>Peso:</b> {master.size}kb
                          {isIABWeight ? 
                          <Tooltip title={`O peso máximo recomendado para este formato é ${pesoMaximo}.`}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                          :
                          <Tooltip title={`O peso máximo recomendado para este formato é ${pesoMaximo}.`}><span className='containerIAB-no'> (✗)</span></Tooltip>
                          }
                          </div>
                          <div className='containerIAB-duration'>
                          <b>Tempo de animação:</b> {(master.duration * master.loop).toFixed(1)}s
                          {master.duration * master.loop <= 15 ?
                          <Tooltip title={'O tempo de animação não deve exceder 15 segundos ou conter looping além dos 15 segundos.'}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                          :
                          <Tooltip title={'O tempo de animação não deve exceder 15 segundos ou conter looping além dos 15 segundos.'}><span className='containerIAB-no'> (✗)</span></Tooltip>
                          }
                          </div>
                        </div>
                        
                        :

                        <div>
                        {isGloboFormat ? 

                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 0 10px', borderBottom: "1px solid #68498c99", borderLeft: "1px solid #68498c99", borderRight: "1px solid #68498c99"}}>
                          <div>
                            <b>Formato:</b> {master.width}x{master.height}
                            <Tooltip title={'Este formato é atualmente aceito pela Globo.'}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                          </div>
                          <div className='containerIAB-weight'>
                          <b>Peso:</b> {master.size}kb
                          {isGloboWeight ? 
                            <Tooltip title={`Peso máximo hosted ${globoWeightHosted}, peso máximo tag ${globoWeightTag}.`}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                            :
                            <Tooltip title={`Peso máximo hosted ${globoWeightHosted}, peso máximo tag ${globoWeightTag}.`}><span className='containerIAB-no'> (✗)</span></Tooltip>
                          }
                          </div>
                          <div className='containerIAB-duration'>
                            <b>Tempo de animação:</b> {(master.duration * master.loop).toFixed(1)}s
                            {master.duration*master.loop <= 15 && master.loop <= 3 ?
                            <Tooltip title={'O tempo de animação máximo recomendado é de 15 segundos com até 3 loopings.'}><span className='containerIAB-yes'> (✓)</span></Tooltip>
                            :
                            <Tooltip title={'O tempo de animação máximo recomendado é de 15 segundos com até 3 loopings.'}><span className='containerIAB-no'> (✗)</span></Tooltip>
                            }
                          </div>
                        </div>

                        :

                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 0 10px', borderBottom: "1px solid #68498c99", borderLeft: "1px solid #68498c99", borderRight: "1px solid #68498c99"}}>
                            <p className='containerIAB-text'>
                            O formato {master.width}x{master.height} não é atualmente aceito pela Globo.
                            </p>
                            <p className='containerIAB-text2'>Clique <a href='https://negocios.globo.com/orientacoes-gerais/' target='_blank'>aqui</a> para saber mais.</p>
                        </div>

                        }
                        </div>
                          
                        }
                        
                    </div>
                    :
                    <div className='iabContainer'>
                        <div className="iabContainerLogosBg">
                          <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none', borderLeft: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none', borderRight: iabTabActive === 'iab' ? "1px solid #68498c99" : 'none'}} onClick={() => handleIabTabActive('iab')} >
                          {isIABWeight ? 
                            <img className='containerIAB-title-yes' src="assets/logo_iab.png"></img>
                          :
                            <img className='containerIAB-title-no' src="assets/logo_iab.png"></img>
                          }
                          </div>
                          <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? 'none' : "1px solid #68498c99", borderLeft: iabTabActive === 'iab' ? 'none' : "1px solid #68498c99", borderRight: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 1)"}} onClick={() => handleIabTabActive('globo')} >
                          {isGloboWeight ?
                            <img className='logoglobo-yes' src="assets/logo_globo.png"></img>
                          :
                            <img className='logoglobo-no' src="assets/logo_globo.png"></img>
                          }
                          </div>
                          <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '0px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? '#FFFFFF' : "1px solid #68498c99"}}></div>
                          <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', position: 'absolute', left: '130px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? "1px solid #68498c99" : '#FFFFFF'}}></div>
                        </div>

                        {iabTabActive === 'iab' ?
                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', padding: '10px 0 0 10px', borderBottom: "1px solid #68498c99", borderLeft: "1px solid #68498c99", borderRight: "1px solid #68498c99"}}>
                            <p className='containerIAB-text'>
                            O formato {master.width}x{master.height} não é atualmente aceito pela IAB.
                            </p>
                            <p className='containerIAB-text2'>Clique <a href='https://iabbrasil.com.br/wp-content/uploads/2019/11/Ebook-IAB-Formatos-Anu%CC%81ncio-A5-DIAGRAMAC%CC%A7A%CC%83O-v4.pdf' target='_blank'>aqui</a> para saber mais.</p>
                        </div>
                        
                        :

                        <div>
                        {isGloboFormat ? 

                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '6px 0 0 10px'}}>
                          
                        </div>

                        :

                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 0 10px', borderBottom: "1px solid #68498c99", borderLeft: "1px solid #68498c99", borderRight: "1px solid #68498c99"}}>
                            <p className='containerIAB-text'>
                            O formato {master.width}x{master.height} não é atualmente aceito pela Globo.
                            </p>
                            <p className='containerIAB-text2'>Clique <a href='https://negocios.globo.com/orientacoes-gerais/' target='_blank'>aqui</a> para saber mais.</p>
                        </div>

                        }
                        </div>
                          
                        }
                        
                    </div>

                    } 
                </div>
			
			: <div></div> }
		</div>
		</>
	)
}

